import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { Subscription, Subject, timer, takeUntil } from 'rxjs';

@Component({
  selector: 'app-lea-timer',
  imports: [],
  templateUrl: './lea-timer.component.html',
  styleUrl: './lea-timer.component.scss'
})
export class LeaTimerComponent {
  public readonly outputExpiredTimer: OutputEmitterRef<void> = output<void>();
  readonly time: InputSignal<number> = input.required();
  public counter!: number;
  public htmlTimer = { days: '00', hours: '00', minutes: '00', seconds: '00' };

  private _intervalSubscription$: Subscription = new Subscription;
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    console.log(this.time())
    this.counter = this.time();
    console.log(this.counter)
    const remainDays = Math.floor((this.counter / 86400));
    const remainHours = Math.floor((this.counter / 3600) % 60);
    const remainMinutes = Math.floor((this.counter / 60) % 60);
    const remainSeconds = Math.floor(this.counter % 60);
    this.htmlTimer.days = `${ remainDays }`;
    this.htmlTimer.hours = `${ remainHours >= 10 ? `${ remainHours }` : `0${ remainHours }` }`;
    this.htmlTimer.minutes = `${ remainMinutes >= 10 ? `${ remainMinutes }` : `0${ remainMinutes }` }`;
    this.htmlTimer.seconds = `${ remainSeconds >= 10 ? `${ remainSeconds }` : `0${ remainSeconds }` }`;
    if (this.counter > 0) {
      if (this._intervalSubscription$) {
        this._intervalSubscription$.unsubscribe();
      }
      this._intervalSubscription$ = timer(1000, 1000).pipe(
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.counter = --this.counter;
        const remainDays = Math.floor((this.counter / 86400));
        const remainHours = Math.floor((this.counter / 3600) % 60);
        const remainMinutes = Math.floor((this.counter / 60) % 60);
        const remainSeconds = Math.floor(this.counter % 60);
        this.htmlTimer.days = `${ remainDays }`;
        this.htmlTimer.hours = `${ remainHours >= 10 ? `${ remainHours }` : `0${ remainHours }` }`;
        this.htmlTimer.minutes = `${ remainMinutes >= 10 ? `${ remainMinutes }` : `0${ remainMinutes }` }`;
        this.htmlTimer.seconds = `${ remainSeconds >= 10 ? `${ remainSeconds }` : `0${ remainSeconds }` }`;
        if (this.counter < 1) {
          this.stopTimer();
        }
      });
    } else {
      this.stopTimer();
    }
  }

  private stopTimer(): void {
    this.outputExpiredTimer.emit();
    this.htmlTimer.days = '0';
    this.htmlTimer.hours = '00';
    this.htmlTimer.minutes = '00';
    this.htmlTimer.seconds = '00';
  }
}
